import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    }
    // else {
    //   body.classList.toggle("vertical-collpsed");
    //   body.classList.toggle("sidebar-enable");
    // }
  }
  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            {/* <li className="menu-title">{props.t("Apps")}</li> */}

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("Products Registrations")}</span>
              </Link>
              <ul className="sub-menu" onClick={e => tToggle()}>
                <li>
                  <Link to="/customer-view-tagged-product">
                    {props.t("View Tagged Products")}
                  </Link>
                </li>
                <li>
                  <Link to="/customer-verify-product">
                    {props.t("Verify Products")}
                  </Link>
                </li>
                <li>
                  <Link to="/customer-activated-product">
                    {props.t("Activated Products")}
                  </Link>
                </li>
                <li>
                  <Link to="/customer-buyback-product-list">
                    {props.t("Refurbished Products List")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-task"></i>
                <span>{props.t("New Orders")}</span>
              </Link>
              <ul className="sub-menu" onClick={e => tToggle()}>
              <li>
                  <Link to="/customer-new-order-request">
                    {props.t("New Paper Requests")}
                  </Link>
                </li>
                <li>
                  <Link to="/customer-view-orders">
                    {props.t("Place Orders")}
                  </Link>
                </li>
               
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Spends")}</span>
              </Link>
              <ul className="sub-menu" onClick={e => tToggle()}>
                <li>
                  <Link to="/customer-reselling-product">
                    {props.t("Total Products Spends")}
                  </Link>
                </li>
                {/* <li>
                  <Link to="/customer-manufactured-product">{props.t("New Order Spends")}</Link>
                </li>   */}
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-envelope"></i>
                <span>{props.t("Services")}</span>
              </Link>
              <ul className="sub-menu" onClick={e => tToggle()}>
                <li>
                  <Link to="/customer-service-list">
                    {props.t("Services List")}
                  </Link>
                </li>
                <li>
                  <Link to="/customer-service-centric">
                    {props.t("Services Centric (Engineer)")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/customer-contact-support" onClick={e => tToggle()}>
                <i className="bx bx-support"></i>
                <span>{props.t("Contact Us")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
